import { API_ENDPOINTS } from "./apiEndpoints";
import { useState, useEffect } from "react";
import { authenticatedFetch } from "./api";
import SearchableSelect from "./SearchableSelect";
import "./ShopifyConverter.css";

function ShopifyConverter() {
  const [vendor, setVendor] = useState("");
  const [vendors, setVendors] = useState([]);
  const [coefficient, setCoefficient] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Load vendor list from backend
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await authenticatedFetch(API_ENDPOINTS.vendors);
        if (!response.ok) throw new Error("Failed to load vendors");
        const data = await response.json();
        setVendors(data.vendors || []);
      } catch (err) {
        console.error("Error loading vendor list:", err);
      }
    };
    fetchVendors();
  }, []);

  const handleSubmit = async () => {
    if (!vendor || !coefficient || !file) {
      alert("Please fill all fields and upload a file.");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("vendor_name", vendor);
    formData.append("variant_coeff", coefficient);
    formData.append("file", file);

    try {
      const response = await authenticatedFetch(API_ENDPOINTS.convert, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to convert file.");

      // Get file as blob and trigger automatic download
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${vendor}_shopify.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert("Error converting file. Check backend logs.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="converter-container">
      <h2>Shopify File Converter</h2>

      <div className="form-group">
        <label>Vendor Name</label>
        <SearchableSelect
          options={vendors}
          value={vendor}
          onChange={(val) => setVendor(val)}
          placeholder="Select vendor..."
          disabled={loading}
        />
      </div>

      <div className="form-group">
        <label>Variant Price Coefficient</label>
        <input
          type="number"
          step="0.1"
          value={coefficient}
          onChange={(e) => setCoefficient(e.target.value)}
          placeholder="e.g. 2.2"
        />
      </div>

      <div className="form-group">
        <label>Upload Inventory File</label>
        <input type="file" onChange={(e) => setFile(e.target.files[0])} />
      </div>

      <button onClick={handleSubmit} disabled={loading}>
        {loading ? "Processing..." : "Convert"}
      </button>
    </div>
  );
}

export default ShopifyConverter;
